import useWidth from '@/helpers/widthUtil';
import { Button } from 'antd';
import React, { useState, useEffect, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { clearMocktestTime } from '@/actions/mock-test';
import { format } from '@/helpers/timeHelper';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { MockTestContext } from '..';
import { isLogin } from '@/helpers/loginHelper';

const QuestionPallete = ({
  toggleQuestionView,
  newAns,
  mulQ,
  scrollIntoQuestionNum,
  answers,
  testStarted,
  setTestStarted,
  data,
  passCount,
  paletteUp,
}) => {
  var duration = data?.data?.duration;
  var a = duration?.split(':'); // split it at the colons
  // minutes are worth 60 seconds. Hours are worth 60 minutes.
  var seconds;
  // var smallTIme = 10;
  const { submit } = useContext(MockTestContext);

  const { isMobile } = useWidth();
  const [count, setCount] = useState(0);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearMocktestTime());
  }, []);

  useEffect(() => {
    try {
      seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
    } catch (err) {
      // console.log(err);
      seconds = 1200;
    }
    setCount(seconds);
    passCount(seconds);
  }, [data?.data]);
  let interValTime;

  useEffect(() => {
    // dispatch(trackCountdown(count));
    if (testStarted) {
      interValTime = setInterval(() => {
        setCount((prevCount) => {
          let counter = prevCount - 1 >= 0 ? prevCount - 1 : 0;
          passCount(counter);
          return counter;
        });
      }, 1000);
    }
    return () => {
      clearInterval(interValTime);
    };
  }, [testStarted]);

  useEffect(() => {
    if (testStarted && count === 0) {
      submit();
    }
  }, [count]);

  var foo = [];
  for (var i = 1; i <= 100; i++) {
    foo.push(i);
  }
  return (
    <div>
      {/* For mobile */}
      <div className="mocktest-rp__question-palette">
        {isLogin() ? (
          isMobile ? (
            <div className="container">
              <>
                <div className="box-ads">
                  <div
                    className="display-question-up"
                    onClick={() => toggleQuestionView()}
                  >
                    {paletteUp ? (
                      <DownOutlined
                        rev=""
                        style={{ fontWeight: '900', fontSize: '18px' }}
                      />
                    ) : (
                      <UpOutlined
                        rev=""
                        style={{ fontWeight: '900', fontSize: '18px' }}
                      />
                    )}
                  </div>
                  <h1 className="text-center">
                    <i className="fas fa-th"></i>{' '}
                    <span>
                      Question palette <i className="fas fa-clock"></i>{' '}
                      {format(count)}
                    </span>
                  </h1>
                  <div className="question-panel mt-5 align-items-center d-flex justify-content-center">
                    <div className="question-palette-items ">
                      {[...Array(data?.data?.question_count)].map((x, i) => {
                        // {foo.map((x, i) => {
                        return (
                          <a
                            className={`question-palette-item ${
                              answers.hasOwnProperty('q-' + (i + 1)) &&
                              answers['q-' + (i + 1)] != ''
                                ? 'answered'
                                : 'unanswered'
                            }`}
                            onClick={(e) => {
                              scrollIntoQuestionNum(i + 1);
                            }}
                            key={i}
                          >
                            {i + 1}
                          </a>
                        );
                      })}
                    </div>
                  </div>
                  <div className="question-bt mt-4 ml-4 d-lg-none d-block">
                    <span className="answered text-white">Answered</span>
                    <span className="unanswered text-white">Unanswered</span>
                  </div>
                </div>
                {/* <div className="question-palette__footer-time-container d-lg-none d-block">
                <div className="time-container text-center mt-5">
                  <i className="fa fa-clock text-white fa-2x"></i>
                  <h3 className="text-white">{format(count)}</h3>
                </div>
              </div> */}
                {testStarted ? (
                  <div className="question-palette__footer-button-container text-center mt-3">
                    <Button className="btn-secondary border-0" onClick={submit}>
                      Submit
                    </Button>
                  </div>
                ) : (
                  <div className="text-center mt-3">
                    <Button
                      className="btn-secondary border-danger"
                      onClick={setTestStarted}
                    >
                      Start Test
                    </Button>
                  </div>
                )}
              </>
            </div>
          ) : (
            <div>
              <div className="justify-content-center m-2 d-flex">
                <h4 className="text-white" style={{ fontSize: '24px' }}>
                  {format(count)}
                </h4>
                <div
                  className="display-question-up"
                  onClick={() => toggleQuestionView()}
                >
                  <i className="fas fa-angle-up fa-2x"></i>
                </div>
              </div>
              <h4 className="text-center text-white" style={{ fontSize: '20px' }}>
                <i className="fas fa-th"></i> <span>Question palette</span>
              </h4>
              <div className="question-panel text-center">
                <div className="question-palette-items">
                  {[...Array(data?.data?.question_count)].map((x, i) => {
                    // {foo.map((x, i) => {
                    return (
                      <a
                        className={`question-palette-item ${
                          answers.hasOwnProperty('q-' + (i + 1)) &&
                          answers['q-' + (i + 1)] != ''
                            ? 'answered'
                            : 'unanswered'
                        }`}
                        onClick={(e) => {
                          scrollIntoQuestionNum(i + 1);
                        }}
                        key={i}
                      >
                        {i + 1}
                      </a>
                    );
                  })}
                </div>
                {testStarted ? (
                  <div className="question-palette__footer-button-container text-center my-5">
                    <Button className="btn-secondary border-0" onClick={submit}>
                      Submit
                    </Button>
                  </div>
                ) : (
                  <div className="text-center my-5">
                    <Button
                      className="btn-secondary border-danger"
                      onClick={setTestStarted}
                    >
                      Start Test
                    </Button>
                  </div>
                )}
              </div>
            </div>
          )
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default QuestionPallete;
